import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Box, Typography, Divider, Skeleton } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import * as Network from '../../../../redux/actions/network.actions';
import * as UIAction from '../../../../redux/actions/ui.actions';
import * as API from '../../../../api/client';
import EntityCard from '../EntityCard';

const FlowTarget = (props) => {
  const { id: flowId, name, description, filterEntity, operation } = props;
  const dispatch = useDispatch();

  const [linked, setLinked] = useState(undefined);
  const supported = useSelector((state) => state.targets.supported && state.targets.supported[flowId]);
  const tenant = useSelector((state) => state.configuration.tenant_id);
  const hideFlows = useSelector((state) => state.ui.hideFlows)
  const hasLinkedTarget = useMemo(() => linked && Object.entries(linked).length > 0, [linked]);
  const linkedTargets = useSelector(state => state.targets.linked)
  const shouldDisable = useSelector(state => state.ui.shouldDisable ?? (() => false))
  const isDisabled = useMemo(() => shouldDisable(flowId), [shouldDisable])
  const byLabel = useCallback(([k1, v1], [k2, v2]) => {
    if (v1.label < v2.label) return -1;
    if (v1.label > v2.label) return 1;
    return 0;
  }, []);

  const handleFilterEntity = useCallback(([id, entity]) => {
    if (typeof filterEntity === 'function') return filterEntity(flowId, entity.target, true)
    return true
  }, [filterEntity])

  useEffect(() => {
    API.getLinkedTargets(null, flowId, tenant).then((response) => {
      setLinked(response);
    });

  }, [linkedTargets]);

  useEffect(() => {
    if (!supported) {
      dispatch(Network.fetchSupportedTargets(flowId));
    }
  }, [supported]);
  if (
    (linked &&
      Object.entries(linked).filter(handleFilterEntity).length === 0 &&
      hasLinkedTarget) ||
    (supported && Object.entries(supported).filter(handleFilterEntity).length === 0 && !hasLinkedTarget)
  )
    return <></>;

  return (
    <Box display="flex" flexDirection={'column'} gap={4}>
      {!hideFlows && <Box display="flex" flexDirection={'column'} gap={1}>
        <Typography className='hg-flow-title' variant="h2" fontWeight="700" color={isDisabled && 'text.disabled'}>{name}</Typography>
        <Typography className='hg-flow-subtitle' variant="body1" fontWeight="400" color={isDisabled ? 'text.disabled' : 'text.lightish'}>
          {description}
        </Typography>
      </Box>}
      <Box display="flex" flexWrap="wrap" gap={3}>
        {!linked && (
          <>
            <Skeleton width={Math.floor(Math.random() * (250 - 200 + 1) + 200)} height={100} />
          </>
        )}
        {linked &&
          Object.entries(linked)
            .filter(handleFilterEntity)
            .sort(byLabel)
            .map(([key, target], index) => {
              return (
                <EntityCard
                  key={`${key}-${flowId}-${index}`}
                  onClickAction={() => UIAction.openEntityConfig(target, 'target', flowId)}
                  entity={target}
                  entityType="target"
                  flowId={flowId}
                  operation={operation}
                  isLinked={true}
                />
              );
            })}
        {linked &&
          supported &&
          !hasLinkedTarget &&
          Object.entries(supported)
            .filter(handleFilterEntity)
            .sort(byLabel)
            .map(([key, target], index) => {
              return (
                <EntityCard
                  key={`${key}-${flowId}-${index}`}
                  onClickAction={() => {
                    UIAction.selectEntityAndFlowId(target, flowId, 'target')
                    API.isEntityLinked(target.target).then((oFlows) => {
                      const filteredFlows = Array.isArray(oFlows) && oFlows.filter((f) => f.id !== flowId);
                      if (filteredFlows && filteredFlows.length > 0) {
                        UIAction.openCopyEntity(target, oFlows, flowId, 'target');
                      } else {
                        UIAction.link(tenant, flowId, target.target, false, { isTarget: true, isConnection: true })
                      }
                    })
                  }
                  }
                  entity={target}
                  flowId={flowId}
                  entityType="target"
                  isLinked={false}
                  operation={operation}
                />
              );
            })}
      </Box>
      {!hideFlows && <Divider />}
    </Box>
  );
};

export default FlowTarget;
